import Input from "./Input";


export default function ComponentsOverrides(theme) {
  return Object.assign(Input(theme));
}
